import { useMutation, UseMutationResult, useQuery } from 'react-query';
import {
  createManualEducation,
  getAcademicList,
  getAcademicInstitutionByLinkedinUrl,
} from '../api/talentsApi';
import { GET_ACADEMICS_FROM } from '../consts';
import { getServerError, isLinkedinUrl } from '../utils';

export const useGetAcademicQuery = (
  academicName:string,
  setTypeCallback: (type: string) => void,
): AcademicResponse => {
  const {
    data,
    isLoading,
  } = useQuery<CompaniesResponse>(['getAcademic', academicName],
    async () => {
      if (academicName.length !== 0) {
        if (isLinkedinUrl(academicName)) {
          setTypeCallback(GET_ACADEMICS_FROM.LINKEDIN);
          const academicInstitution = await getAcademicInstitutionByLinkedinUrl(academicName);

          return [academicInstitution];
        }
        setTypeCallback(GET_ACADEMICS_FROM.DB);

        const academicResponse = await getAcademicList(academicName);

        return academicResponse?.results;
      }

      return null;
    }, {
      retry: false,
    });

  return {
    academics: data || [],
    isLoading,
  };
};

type Error = {
  hasError:boolean,
  errorMessage: string,
}

export const useCreateNewManualEducation = (
  onSuccessCallback: (instituteId: string) => void,
  onErrorCallback: (object: Error)=> void,
): UseMutationResult<Academic, ServerError, CreateManualEducationRequest, unknown> => {
  const mutation = useMutation((query:CreateManualEducationRequest) => {
    return createManualEducation(query);
  }, {
    onSuccess: (response: Academic) => {
      onSuccessCallback(response?.id || '');
    },
    onError: (error:ServerError) => {
      const errorMessage = getServerError(error);
      onErrorCallback({
        hasError: true,
        errorMessage,
      },
      );
    },
  });

  return mutation;
};
